import { RwGlyph, RwCurrency } from '@components/atoms';
import { t } from '@services/i18n';
import { txnTypeMap } from '@shared/data/fixtures';
import type { MyLedgerEntry } from '@shared/types/me';

/**
 * Per-row personal ledger list — icon by txn type, what/why/expiry, and a
 * signed currency amount. Shared by the member dashboard (recent activity,
 * sliced) and "My rewards" (full, segmented-filtered). Renders from fixtures;
 * the live `transactions` projection swaps in later.
 */
function txnIcon(type: MyLedgerEntry['type']): string {
  return type === 'deduct' || type === 'reversal' || type === 'expire'
    ? 'archive'
    : type === 'grant'
      ? 'spark'
      : 'compass';
}

export function MyLedger({ rows }: { rows: MyLedgerEntry[] }) {
  return (
    <div className="rw-mled">
      {rows.map((r) => {
        const tt = txnTypeMap[r.type];
        return (
          <div key={r.id} className="rw-mled-row">
            <div className="rw-mled-icon">
              <RwGlyph kind={txnIcon(r.type)} size={16} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 500 }}>{r.what}</div>
              <div className="rw-fg2 rw-mono" style={{ fontSize: 11, marginTop: 2 }}>
                {r.rule ? `${r.rule} · ` : ''}
                {r.at}
                {r.expires ? ` · ${t('COM_REWARDIFY_MYLEDGER_EXPIRES', 'expires %s', r.expires)}` : ''}
              </div>
            </div>
            <RwCurrency id={r.currency} amount={r.amount} sign={tt ? tt.sign : undefined} />
          </div>
        );
      })}
    </div>
  );
}
